import React, { Component } from "react";
import Grid from '@mui/material/Grid';
import SpinnerModal from "@components/SpinnerModal";
import { useDialog } from 'react-st-modal';
import styles from './permissionrolesdialog.module.css';
import SupportAlert from '@components/SupportAlert';
import RolePermissionManagementService from '@services/RolePermissionManagementService';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Switch from '@mui/material/Switch';
import { Alert, Table, TableHead, TableBody, TableCell, TableContainer, TableRow, Tooltip, Paper, Checkbox } from '@mui/material';

class PermissionRolesDialog extends Component {
    state = {
        loading: false,
        currentUserId: null,
        systemRoles: [],
        rolePermissions: [],

        permissionName: '',
        permissionDescription: '',
        permissionResource: '',
        permissionAction: '',
        permissionActive: false,

        validPermissionName: true,
        validPermissionResource: true,
        validPermissionDescription: true,
        validPermissionAction: true,
        validPermissionActive: true,

        resourceOptions: [
            { value: 'RDI', label: 'RDI' }
        ],

        selectedPermission: null,
    }

    parseJwt(token) {
        const base64Payload = token.split('.')[1];
        const payload = atob(base64Payload);
        return JSON.parse(payload.toString());
    }

    async componentDidMount() {
        this.setState({ loading: true });

        let payload = this.parseJwt(localStorage.getItem('Bearer'));
        this.setState({ currentUserId: payload.user_id });

        this.setState({ selectedPermission: this.props.permission });

        await (async () => {
            try {
                const systemRolePermissions = await RolePermissionManagementService.getRdiSystemRolePermissionsByPermissionId(this.props.permission.id);
                this.setState({ rolePermissions: JSON.parse(JSON.stringify(systemRolePermissions)) });
                return systemRolePermissions;
            } catch (ex) {
                console.log('Network error loading system role-permissions');
            }
        })([]);

        this.reloadSystemRoles();

        this.setState({ loading: false });
    }

    async reloadSystemRoles() {
        this.setState({ loading: true });

        await (async () => {
            try {
                const systemRolesAll = await RolePermissionManagementService.getRdiSystemRoles();
                this.setState({ systemRoles: JSON.parse(JSON.stringify(systemRolesAll)) });
                return systemRolesAll;
            } catch (ex) {
                console.log('Network error loading system roles');
            }
        })([]);

        this.setState({ loading: false });
    }

    handleRoleCheckboxClick = (event, systemRole) => {
        const isChecked = event.target.checked;

        // Update your state or perform actions based on the checkbox change
        this.createRolePermission(systemRole, this.state.selectedPermission);
        this.setState(prevState => ({
            rolePermissions: isChecked
                ? [...prevState.rolePermissions, systemRole]
                : prevState.rolePermissions.filter(rolePermission => rolePermission.role.id !== systemRole.id)
        }));
    }

    createRolePermission(role, permission) {
        return {
            id: {
                roleId: role.id,
                permissionId: permission.id
            },
            role: role,
            permission: permission,
            grantType: 'ALLOW'
        };
    }

    async handleFlipRolePermissionGrantType(evt, roleId) {
        if (this.state.rolePermissions.some(rolePermission => rolePermission.id.roleId === roleId)) {
            const updateRolePermission = this.state.rolePermissions.find(rolePermission => rolePermission.id.roleId === roleId);
            updateRolePermission.grantType = (updateRolePermission.grantType === 'ALLOW' ? 'DENY' : 'ALLOW');

            (async () => {
                try {
                    const rolePermissionEnvelope = [{
                        actionById: this.state.currentUserId,
                        roleId: updateRolePermission.id.roleId,
                        permissionId: updateRolePermission.id.permissionId,
                        grantType: updateRolePermission.grantType
                    }]
                    await RolePermissionManagementService.saveRolePermission(rolePermissionEnvelope);
                    this.setState({ rolePermissions: [...this.state.rolePermissions.filter(rolePermission => rolePermission.id.roleId !== roleId), updateRolePermission] });
                } catch (ex) {
                    console.log('Error updating role-permission: ' + ex);
                }
            })([]);
        }
    }

    getData() {

        let data = {
            actionById: this.props.surveysUserId,
            rdiPermission: {
                id: this.props.permission.id,
                name: this.state.permissionName,
                description: this.state.permissionDescription,
                resource: this.state.permissionResource,
                action: this.state.permissionAction,
                active: this.state.permissionActive
            }
        };

        return data;

    }

    dialogBody() {
        return <div className={styles.flex_row_container}>
            <div className={styles.featuredItem}>
                <Alert variant="outlined" severity="warning">{'You are about update role permission grants. Please be careful since all changes are applied immediately.'}</Alert>
            </div>
            <div className={styles.featuredItem}>
                <h1>
                    <text className={styles.featuredTitleHeader}>{"Roles granted the permission : " + this.props.permission.name}</text>
                </h1>
                <br />
                <p>
                    <Grid container spacing={3} direction="column" justify-content="space-between" wrap="nowrap">
                        {(this.state.rolePermissions !== undefined && this.state.rolePermissions !== null && this.state.rolePermissions.length > 0)
                            ? (
                                <div className={styles.featuredItem}>
                                    <TableContainer component={Paper} elevation={0}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={styles.table_header_cell}>
                                                        <text className={styles.featuredTitleHeader}>{
                                                            'GRANTED'
                                                        }</text>
                                                    </TableCell>
                                                    <TableCell className={styles.table_header_cell}>
                                                        <text className={styles.featuredTitleHeader}>{
                                                            'ROLE NAME'
                                                        }</text>
                                                    </TableCell>
                                                    <TableCell className={styles.table_header_cell}>
                                                        <text className={styles.featuredTitleHeader}>{'GRANT TYPE'}</text>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.systemRoles.sort((a, b) => a.id > b.id ? 1 : -1).map(systemRole => {
                                                    return (
                                                        <Tooltip
                                                            key={systemRole.name}
                                                            title={systemRole.description}
                                                            followCursor
                                                            placement="top-start"
                                                            componentsProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        bgcolor: '#0078D4',
                                                                        color: 'white',
                                                                        fontSize: '12px',
                                                                        padding: '10px',
                                                                        borderRadius: '5px',
                                                                        maxWidth: '100%',
                                                                        '& .MuiTooltip-arrow': {
                                                                            color: '#0078D4'
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            <TableRow
                                                                key={systemRole.name}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >
                                                                <TableCell component="td">
                                                                    <Checkbox
                                                                        disabled={true}
                                                                        checked={this.state.rolePermissions.some(rolePermission => rolePermission.role?.id === systemRole.id)}
                                                                        size="small"
                                                                        onChange={(event) => this.handleRoleCheckboxClick(event, systemRole)}
                                                                        color="primary"
                                                                        sx={{
                                                                            '&.MuiCheckbox-root': {
                                                                                padding: '4px',
                                                                            },
                                                                            '& .MuiSvgIcon-root': {
                                                                                width: '20px',
                                                                                height: '20px'
                                                                            }
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell component="td">
                                                                    <text className={styles.featuredText}>
                                                                        {systemRole?.name?.toUpperCase()}
                                                                    </text>
                                                                </TableCell>
                                                                <TableCell component="td">
                                                                    <FormControl>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Switch
                                                                                    disabled={!this.state.rolePermissions.some(rolePermission => rolePermission.role?.id === systemRole.id)}
                                                                                    name='allow_role_permission'
                                                                                    size='small'
                                                                                    color='primary'
                                                                                    checked={(this.state.rolePermissions.filter(rolePermission => (rolePermission.role?.id === systemRole?.id))[0]?.grantType?.toUpperCase() === 'ALLOW')}
                                                                                    onChange={(evt) => {
                                                                                        this.handleFlipRolePermissionGrantType(evt, systemRole.id)
                                                                                    }}
                                                                                />
                                                                            }
                                                                            label={(this.state.rolePermissions.filter(rolePermission => rolePermission.role?.id === systemRole?.id)[0]?.grantType?.toUpperCase() === 'ALLOW') ? "ALLOW" : "DENY"}
                                                                        />
                                                                    </FormControl>
                                                                </TableCell>
                                                            </TableRow>
                                                        </Tooltip>
                                                    )
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            )
                            : (

                                <div className={styles.featuredItem}>
                                    <Alert variant="outlined" severity="warning">
                                        {"No roles have the [ " + this.props.permission.name?.toUpperCase() + " ] permission"}
                                    </Alert>
                                </div>
                            )
                        }
                    </Grid>
                </p>
            </div>
        </div>
    }

    render() {
        if (this.state.loading === true) {
            return <SpinnerModal settings={true} label={'Dialog loading ...'} />
        } else {
            return <DialogWrapper
                {...this.props}
                onClick={(evt) => this.props.nextButton.onClick(evt, this.getData())}
                validDetails={(this.state.validPermissionName === true) &&
                    (this.state.validPermissionResource === true) &&
                    (this.state.validPermissionDescription === true) &&
                    (this.state.validPermissionAction === true) &&
                    (this.state.validPermissionActive === true)}
                content={
                    <React.Fragment>
                        {this.dialogBody()}
                    </React.Fragment>
                }
            />
        }
    }

}
export default PermissionRolesDialog;

function DialogWrapper(props) {
    const dialog = useDialog();

    return (
        <div>
            <br />
            <div>
                {props.content}
            </div>
            <div>
                {props.backButton !== undefined && props.backButton !== null
                    ? <button type="button" className="btnBack"
                        onClick={() => {
                            dialog.close(false);
                        }}
                    >
                        {props.backButton.text}
                    </button>
                    : <div />
                }
                {props.nextButton !== undefined && props.nextButton !== null
                    ? <button type="button" className="btnNext"
                        onClick={(evt) => {
                            if (!props.validDetails) {
                                SupportAlert.displayAlert('Updating permission failed', 'Please review supplied information carefully.');
                            } else {
                                props.onClick(evt);
                                dialog.close(true);
                            }
                        }}
                    >
                        {props.nextButton.text}
                    </button>
                    : <div />
                }
            </div>
        </div>
    );
}

